import SvgCreditcard from '@sats-group/icons/24/creditcard';
import SvgBarbell from '@sats-group/icons/24/strength';
import Button from '@sats-group/ui-lib/react/button';
import Checkbox from '@sats-group/ui-lib/react/checkbox';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import FlowLayout from '~/client/components/flow-layout/flow-layout';
import type { RenewPreview as Props } from './renew-preview.types';

const RenewPreview: React.FC<Props> = ({ layout, summary, copy }) => (
  <FlowLayout {...layout}>
    {summary ? (
      <div className="renew-preview">
        <section className="renew-preview__main">
          <div className="renew-preview__header">
            <Text
              elementName="h2"
              size={Text.sizes.large}
              theme={Text.themes.headline}
            >
              {copy.detailsTitle}
            </Text>
          </div>

          <div className="renew-preview__details">
            {summary.renewalDetails.map((detail, index) => (
              <div key={index} className="renew-preview__details-item">
                <Text theme={Text.themes.emphasis} size={Text.sizes.small}>
                  {detail.label}
                </Text>
                <Text size={Text.sizes.small}>{detail.value}</Text>
              </div>
            ))}
          </div>

          <div className="renew-preview__price-text">
            <Text theme={Text.themes.emphasis} size={Text.sizes.small}>
              {summary.price.title}
            </Text>
          </div>
          <div className="renew-preview__prices">
            {summary.price.lines.map(entry => (
              <div className="renew-preview__price" key={entry.text}>
                <Text
                  size={
                    entry.important ? Text.sizes.headline3 : Text.sizes.small
                  }
                  theme={entry.important ? Text.themes.emphasis : undefined}
                >
                  {entry.text}
                </Text>
                {entry.post ? (
                  <Text
                    size={entry.important ? Text.sizes.basic : Text.sizes.small}
                    theme={entry.important ? Text.themes.emphasis : undefined}
                  >
                    {entry.post}
                  </Text>
                ) : null}
              </div>
            ))}
          </div>
        </section>
        <section className="renew-preview__about-change">
          <Text theme={Text.themes.headline} size={Text.sizes.large}>
            {copy.aboutChangeTitle}
          </Text>
          <div className="renew-preview__about-change-item">
            <SvgBarbell />
            <Text>{summary.validityText}</Text>
          </div>
          {summary.sponsorshipText ? (
            <div className="renew-preview__about-change-item">
              <SvgCreditcard />
              <Text>{summary.sponsorshipText}</Text>
            </div>
          ) : null}
        </section>
        <form action={summary.form.action} method={summary.form.method}>
          {summary.form.data.map(entry => (
            <HiddenInput {...entry} key={entry.name} />
          ))}
          <section className="renew-preview__terms">
            <Checkbox {...summary.form.terms.checkbox} />
            <LinkButton
              {...summary.form.terms.link}
              variant={LinkButton.variants.secondary}
            />
          </section>
          <Button {...summary.form.submit} type="submit" wide />
        </form>
      </div>
    ) : null}
  </FlowLayout>
);

export default RenewPreview;
